import type { Distance, Margins, SpatialRectangle } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import type { StringGUID } from "@pdfking/tfunc"

import { PageMetrics } from "../layout/PageMetrics"
import { DrawBackpackGrid } from "../pattern/DrawBackpackGrid"
import { CreateRandom } from "../random/CreateRandom"
import { DrawExLibris } from "./DrawExLibris"

// The inside of the front cover in `box`: the pattern as endpaper, and on it
// an ex libris plate; the pattern runs on into `bleed`
export const DrawFrontCoverBack = ({
  bleed,
  box,
  seed,
}: {
  bleed: Margins<Distance>
  box: SpatialRectangle<Distance>
  seed: StringGUID
}): PageShape[] => [
  ...DrawBackpackGrid({
    bleed,
    box,
    random: CreateRandom(seed, "front cover back"),
    short: PageMetrics(box).short,
  }),
  ...DrawExLibris(box),
]
